import { createContext, useContext } from 'react';

type KYCLayout = {
  isMobile: boolean;
};

const KYCLayoutContext = createContext<KYCLayout>({ isMobile: false });

const KYCLayoutProvider = KYCLayoutContext.Provider;

function useKYCLayout(): KYCLayout {
  return useContext(KYCLayoutContext);
}

export { KYCLayoutProvider, useKYCLayout };
export type { KYCLayout };
